import { create } from 'zustand';
import axiosInstance from '@/apis/axiosInstance';
import toast from 'react-hot-toast';
import { growthbook } from '@/index';
import { useMultiplePricesStore } from '@/hooks/useMultiplePricesStore';
import i18n from '@/i18n';
import { useWebModalStore } from '@/hooks/useWebModalStore';

const reQueryDetailData = async ({
  orderId,
  validate,
  clearDateAndUpdate = false,
  setMyRate = false
}: {
  orderId: string;
  validate?: boolean;
  clearDateAndUpdate?: boolean;
  setMyRate?: boolean;
}) => {
  try {
    window.localStorage.setItem('auth_redirect', `/campaign/detail/${orderId}`);
    window.localStorage.setItem('homepage', `/campaign/detail/${orderId}`);
    if (setMyRate) {
      useDetailDataStore.setState({ myRateLoading: true });
    } else {
      useDetailDataStore.setState({ isLoadingData: true });
    }
    if (clearDateAndUpdate) {
      // 重新进入 置空
      useDetailDataStore.setState({ detailData: {} });
    }
    //
    let url = `/order/detail/${encodeURIComponent(orderId)}`;
    if (validate) {
      url += `?validate=${validate}`;
    }
    // 同时发出请求
    const [detailResponse] = await Promise.allSettled([axiosInstance.get(url)]);

    // 处理订单详情
    if (detailResponse.status === 'fulfilled') {
      const detailData = detailResponse.value.data.data;

      if (!detailData.order) {
        toast.error(
          i18n.t('order.detail.not_found_error', {
            defaultValue:
              'Unable to find this order, please contact customer service.'
          })
        );
        return;
      } else {
        // 获取
        getGrowthbookFlag(detailData);
        console.log(
          'detailData.order.priceFields',
          detailData.order.priceFields
        );
        detailData.order.priceFields.forEach((el: any) => {
          // 添加 originPrice 字段，用于备份原始价格
          el.originPrice = el.price;
        });

        // 设置默认选择 index 0 的价格
        useMultiplePricesStore.setState({
          selectedPriceFields: [detailData.order.priceFields[0]]
        });
      }

      useDetailDataStore.setState({ detailData });
      return detailData;
    } else {
      console.log('detailResponse', detailResponse);
      console.error('Failed to get order details:', detailResponse.reason);
      if (detailResponse.reason.message === '401 Unauthorized') {
        toast.error(
          i18n.t('order.detail.unauthorized_error', {
            defaultValue: '401 Unauthorized. Please login again.'
          })
        );
      } else if (detailResponse.reason.message === '403 Forbidden') {
        const { payload } = detailResponse.reason;
        if (payload?.ownerEmail) {
          toast.error(
            i18n.t('order.detail.forbidden_error_2', {
              defaultValue:
                'This deal is associated with the account registered under the email {{ownerEmail}}. Please sign in with this account to access the deal details.',
              ownerEmail: payload?.ownerEmail
            })
          );
        } else {
          toast.error(
            i18n.t('order.detail.forbidden_error', {
              defaultValue: 'Your session has expired. Please log in again.'
            })
          );
        }
      } else if (
        detailResponse.reason.message === 'order not found' &&
        detailResponse.reason.payload?.deletedReason
      ) {
        useWebModalStore?.setState({
          showModalSoftDeleteTip: true,
          softDeleteReason: detailResponse.reason.payload?.deletedReason || ''
        });
      } else {
        toast.error(
          i18n.t('order.detail.fetch_error', {
            defaultValue:
              'This collaboration has ended and is no longer valid. For any questions, please contact our support team.'
          })
        );
      }
    }
  } catch (e: any) {
    toast.error(
      e.message ||
        i18n.t('order.detail.generic_error', {
          defaultValue: 'Failed to get data.'
        })
    );
  } finally {
    if (setMyRate) {
      useDetailDataStore.setState({ myRateLoading: false });
    } else {
      useDetailDataStore.setState({ isLoadingData: false });
    }
  }
};

type DetailDataStore = {
  detailData: any;
  setDetailData: (detailData: any) => void;
  duringFirstOrder: boolean;
  setDuringFirstOrder: (duringFirstOrder: boolean) => void;
  reQueryDetailData: ({
    orderId,
    validate,
    clearDateAndUpdate,
    setMyRate
  }: {
    orderId: string;
    validate?: boolean;
    clearDateAndUpdate?: boolean;
    setMyRate?: boolean;
  }) => Promise<any>;
  isLoadingData: boolean;
  setIsLoadingData: (isLoadingData: boolean) => void;
  myRateLoading: boolean;
  setMyRateLoading: (myRateLoading: boolean) => void;
  titleType: string;
  setTitleType: (titleType: string) => void;
};

export const useDetailDataStore = create<DetailDataStore>((set) => ({
  isLoadingData: true,
  setIsLoadingData: (isLoadingData: boolean) => set({ isLoadingData }),
  myRateLoading: false,
  setMyRateLoading: (myRateLoading: boolean) => set({ myRateLoading }),
  detailData: {},
  setDetailData: (detailData: any) => set({ detailData }),
  duringFirstOrder: true,
  setDuringFirstOrder: (duringFirstOrder: boolean) => set({ duringFirstOrder }),
  reQueryDetailData,
  titleType: '',
  setTitleType: (titleType: string) => set({ titleType })
}));

const getGrowthbookFlag = (detailData: any) => {
  if (detailData?.order?.campaignId && detailData?.order?._id) {
    growthbook.setAttributes({
      id: detailData.order.campaignId + detailData.order._id,
      url: window.location.href,
      path: window.location.pathname,
      host: window.location.host,
      query: window.location.search,
      deviceType: 'foo',
      browser: navigator.userAgent,
      utmSource: 'foo',
      utmMedium: 'foo',
      utmCampaign: 'foo',
      utmTerm: 'foo',
      utmContent: 'foo',
      platform_user_id: detailData?.user?.__id || 'foo',
      campaign_id: detailData.order.campaignId
    });
  }
};
